<template>
  <div class="changestate">
    <!-- <img
      src="../../../assets/images/erweima.png"
      class="erweima"
      v-show="show"
      @click="shows"
    />
    <img
      src="../../../assets/images/accLogin.png"
      class="erweima"
      v-show="!show"
      @click="show = !show"
    /> -->
    <div class="left">
      <view-track ref="trackRef"></view-track>
    </div>
    <div class="line"></div>
    <div class="right">
      <ul class="changestateul" v-show="show">
        <li
            v-for="(tab, index) in tabs"
            :key="index"
            @click="toggle(index, tab.view)"
            :class="{ active: active == index }"
        >
          {{ tab.type }}
        </li>
        <div class="clearfix"></div>
      </ul>
      <div class="clearfix"></div>
      <!--:is实现多个组件实现同一个挂载点-->
      <component
          :is="currentView"
          v-if="show"
          :acceptCheck="acceptCheck"
          @changeAcceptCheck="changeAcceptCheck"
      ></component>
    </div>
  </div>
</template>

<script>
import zuaChangeStatefirst from "./zuaChangeStatefirst";
import zuaViewStatus from "./zuaViewStatus";
import ViewTrack from "./ViewTrack";
export default {
  name: "zuaChangeState",
  components: {
    zuaChangeStatefirst,
    zuaViewStatus,
    ViewTrack,
  },
  data: function () {
    return {
      active: 0,
      currentView: "zuaChangeStatefirst",
      tabs: [
        {
          type: "账户登录",
          view: "zuaChangeStatefirst",
        },
        {
          type: "手机验证码登录",
          view: "zuaViewStatus",
        },
      ],
      show: true,
      acceptCheck: false,
    };
  },
  methods: {
    toggle(i, v) {
      this.active = i;
      this.currentView = v;
      this.show = true;
    },
    shows() {
      if (this.acceptCheck) {
        this.show = !this.show;
      } else {
        this.$confirm({
          title: "请阅读并同意",
          content: (h) =>
              h("span", [
                "阅读并同意",
                h(
                    "span",
                    {
                      class: "clickText",
                      style: {
                        color: "#1890ff",
                        cursor: "pointer",
                        marginLeft: "2px",
                        marginRight: "2px",
                      },
                      on: {
                        mousedown: (e) => e.preventDefault(),
                        click: (e) => {
                          e.stopPropagation();
                          this.handleUserAgree(e);
                        },
                      },
                    },
                    "用户协议"
                ),
                "和",
                h(
                    "span",
                    {
                      class: "clickText",
                      style: {
                        color: "#1890ff",
                        cursor: "pointer",
                        marginLeft: "2px",
                        marginRight: "2px",
                      },
                      on: {
                        mousedown: (e) => e.preventDefault(),
                        click: (e) => {
                          e.stopPropagation();
                          this.handlePrivacyPolicy(e);
                        },
                      },
                    },
                    "隐私政策"
                ),
              ]),
          okText: "同意并继续",
          cancelText: "取消",
          onOk: () => {
            this.acceptCheck = true;
            this.show = !this.show;
          },
          onCancel() {},
        });
      }
    },
    changeAcceptCheck() {
      this.acceptCheck = !this.acceptCheck;
    },
    handleUserAgree(event) {
      event.preventDefault();
      window.open("https://app.jxjypt.cn/yhxy.html", "_blank");
    },
    handlePrivacyPolicy(event) {
      event.preventDefault();
      window.open("https://app.jxjypt.cn/yszc.html", "_blank");
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.changestate{
  width:860px;
  margin-top:10px;
  position:relative;
  margin:0 auto;
  background:#fff;
  border:10px solid #a9e0bf;
  padding-left:-20px;
  padding:28px;
  display:flex;
  .left{
    width:300px;
    height:340px;
    margin-right:30px;
  }
  .line{
    width:1px;
    background:#dddddd;
    margin-right:30px;
  }
  .right{
    flex:1;
  }
  .erweima{
    position:absolute;
    top:15px;
    right:15px;
  }
  .changestateul{
    margin-top:10px;
    border-bottom:1px solid #dddddd;
  }
  .changestateul li{
    float:left;
    margin-right:30px;
    height:32px;
    font-size:16px;
    font-weight:bold;
    line-height:32px;
    cursor:pointer;
    text-align:center;
    border-radius:3px;
    &.active{
      color:$bgColor;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginIndex/components/zuaChangeState.vue